import * as actionTypes from '../actions/actionTypes';

const initialState = {
    ordersToday: {
        items: [],
        loading: true,
        error: false
    },
    ordersTomorrow: {
        items: [],
        loading: true,
        error: false
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ORDERS_TODAY:
            return {
                ...state,
                ordersToday: {
                    items: action.orders,
                    loading: false,
                    error: false
                }
            };
        case actionTypes.SET_ORDERS_TOMORROW:
            return {
                ...state,
                ordersTomorrow: {
                    items: action.orders,
                    loading: false,
                    error: false
                }
            };
        case actionTypes.FETCH_ORDERS_TODAY_FAILED:
            return {
                ...state,
                ordersToday: {
                    items: [],
                    loading: false,
                    error: true
                }
            };
        case actionTypes.FETCH_ORDERS_TOMORROW_FAILED:
            return {
                ...state,
                ordersTomorrow: {
                    items: [],
                    loading: false,
                    error: true
                }
            };
        case actionTypes.FETCH_ORDERS_STARTING:
            return {
                ...state,
                ordersToday: {
                    items: [],
                    loading: true,
                    error: false
                },
                ordersTomorrow: {
                    items: [],
                    loading: true,
                    error: false
                }
            };
        default:
            return state;
    }
};

export default reducer;